import {ReactNode} from 'react'

const FLAGS = () => ({
  ...(window as any).Config.featureFlags,
})

export const isFlagEnabled = (
  flagName: string,
  equals?: string | boolean
): boolean => {
  let localStorageFlags
  let _equals = equals

  try {
    localStorageFlags = JSON.parse(window.localStorage.quartzFlags)
  } catch {
    localStorageFlags = {}
  }

  if (_equals === undefined) {
    _equals = true
  }

  if (localStorageFlags.hasOwnProperty(flagName)) {
    return localStorageFlags[flagName] === _equals
  }

  if (FLAGS().hasOwnProperty(flagName)) {
    return FLAGS()[flagName] === _equals
  }

  return false
}

// type quartz.toggleFeature('myFlag') to disable / enable any feature flag
export const FeatureFlag = ({
  name,
  equals,
  children,
}: {
  name: string
  equals?: string | boolean
  children?: ReactNode
}): JSX.Element => {
  if (!isFlagEnabled(name, equals)) {
    return null
  }

  return children as any
}

export const getUserFlags = function getUserFlags() {
  const flagKeys = Object.keys(FLAGS())

  const flags = {}
  flagKeys.forEach((key) => {
    flags[key] = isFlagEnabled(key)
  })

  return flags
}

/* eslint-disable no-console */
const list = () => {
  console.log('Currently Available Feature Flags')
  console.table(getUserFlags())
}
/* eslint-enable no-console */

const reset = () => {
  const quartzFlags = JSON.parse(window.localStorage.quartzFlags || '{}')

  Object.keys(quartzFlags).forEach((k) => {
    if (!FLAGS().hasOwnProperty(k)) {
      delete quartzFlags[k]
    } else {
      quartzFlags[k] = FLAGS()[k]
    }
  })

  window.localStorage.quartzFlags = JSON.stringify(quartzFlags)
}

export const set = (flagName: string, value: string | boolean) => {
  const quartzFlags = JSON.parse(window.localStorage.quartzFlags || '{}')

  quartzFlags[flagName] = value

  window.localStorage.quartzFlags = JSON.stringify(quartzFlags)

  return quartzFlags[flagName]
}

export const toggleLocalStorageFlag = (flagName: string) => {
  const quartzFlags = JSON.parse(window.localStorage.quartzFlags || '{}')

  quartzFlags[flagName] = !quartzFlags[flagName]

  window.localStorage.quartzFlags = JSON.stringify(quartzFlags)

  return quartzFlags[flagName]
}

// Expose utility in dev tools console for convenience
const w: any = window

w.quartz = {toggleFeature: toggleLocalStorageFlag, list, reset, set}
